import WidgetModule from "@eisinc/Overrides/Widgets/Common/CartApproverMessage";

export * from "@eisinc/Overrides/Widgets/Common/CartApproverMessage";

export default WidgetModule;
